export const CamelCase = (word) => {
  return word && word?.length > 0
    ? word.slice(0, 1).toUpperCase() + word.slice(1, word.length).toLowerCase()
    : null;
};
